module.exports = __webpack_public_path__ + "img/restorative-forest.ea30c488.jpg";